import {
    AfterViewInit,
    Component,
    Directive,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    ViewChild,
} from '@angular/core';

@Directive({
    selector: '[ops-accordion-header]',
    standalone: false
})
export class OpsAccordionHeaderDirective {}

@Directive({
    selector: '[ops-accordion-content]',
    standalone: false
})
export class OpsAccordionContentDirective {}

@Component({
    selector: 'app-ops-accordion',
    templateUrl: './ops-accordion.component.html',
    styleUrls: ['./ops-accordion.component.scss'],
    standalone: false
})
export class OpsAccordionComponent implements AfterViewInit, OnChanges, OnDestroy {
    @ViewChild('contentContainer', { static: true }) contentContainer;
    @ViewChild('content', { static: true }) content;

    @Input() isOpen: boolean = true;

    contentStyle = {};
    contentHeight = '0px';

    resizeObserver: ResizeObserver = null;

    constructor() {
        this.updateContentContainerHeight = this.updateContentContainerHeight.bind(this);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.isOpen) {
            this.updateContentContainerHeight();
        }
    }

    ngAfterViewInit(): void {
        this.updateContentContainerHeight();

        this.contentStyle = {
            'transition-property': 'height',
            'transition-duration': '.18s',
            'transition-timing-function': 'linear',
        };

        this.resizeObserver = new ResizeObserver(() => {
            this.updateContentContainerHeight();
        });
        this.resizeObserver.observe(this.content.nativeElement);
    }

    ngOnDestroy(): void {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    updateContentContainerHeight() {
        this.contentContainer.nativeElement.style.height = this.isOpen
            ? this.content.nativeElement.offsetHeight + 'px'
            : '0px';
    }

    toggleOpen() {
        this.setOpen(!this.isOpen);
    }

    setOpen(open: boolean) {
        this.isOpen = open;
        this.updateContentContainerHeight();
    }
}
